import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from "react-toastify";
import logo from '../images/bankist-green.png';

export default function Login({ userAccount, setUserAccount, setIsLoggedIn, setLoggedUser }) {
    const [isLogin, setIsLogin] = useState(true);
    const [name, setName] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [checkName, setCheckName] = useState("");
    const [checkPassword, setcheckPassword] = useState("");
    const [checkUser, setCheckUser] = useState("");

    const uId = uuidv4();

    const checkAlert = (text) => {
        setCheckUser(text)
        const timer = setTimeout(() => {
            setCheckUser("")
        }, 2000)
        return () => clearTimeout(timer)
    }

    const handleCreateAccount = (e) => {
        e.preventDefault();
        if (!name || !userName || !password) return;
        const checkUser = userAccount.find((user) => user.userName === userName)
        if (checkUser) {
            checkAlert("User laready exist!");
            setName("");
            setUserName("");
            setPassword("");
        }
        else {
            const user = { id: uId, name: name, userName: userName, password: password, interestRate: 1.5, photo: `https://i.pravatar.cc/48?u=${Date.now()}`, status: true, movements: [] }
            setUserAccount((userAccount) => [...userAccount, user]);
            toast.success("Account created successfully!");
            setName("");
            setUserName("");
            setPassword("");
            setIsLogin(true);
        }
    }
    const handleLogin = (e) => {
        e.preventDefault();
        if (!checkName || !checkPassword) return;
        const user = userAccount.find((item) => item.userName === checkName && item.password === checkPassword && item.status === true);
        if (!user) {
            checkAlert("Account not found!");
        } else {
            setLoggedUser([user]);
            setIsLoggedIn(true);
        }
        setCheckName('');
        setcheckPassword('');
    }

    return (
        <div div className="container">
            <ToastContainer />
            {isLogin ? <div className="form-card">
                <img src={logo} alt='bank logo' className='logo' />
                <h4>
                    Welcome back
                </h4>
                <h5>(Username: hussu) (Password: 12345)</h5>
                <p className='alert-msg'>{checkUser}</p>
                <form onSubmit={handleLogin}>
                    <div className="form-field">
                        <label>Username</label>
                        <div className="input-group">
                            <input
                                placeholder="Your username"
                                type="text"
                                value={checkName}
                                onChange={(e) => setCheckName(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-field">
                        <label>Password</label>
                        <div className="input-group">
                            <input
                                placeholder="Your password"
                                type="password"
                                value={checkPassword}
                                onChange={(e) => setcheckPassword(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-field">
                        <input type="submit" value="Log in" className="btn btn-primary" />
                    </div>
                </form>
                <p>Don't have an account? <span onClick={() => setIsLogin(false)} className='change-btn'>Create an account</span></p>
            </div> : <div className="form-card">
                <img src={logo} alt='bank logo' className='logo' />
                <h4>
                    Create your account
                </h4>
                <p className='alert-msg'>{checkUser}</p>
                <form onSubmit={handleCreateAccount}>
                    <div className="form-field">
                        <label>Name</label>
                        <div className="input-group">
                            <input placeholder="Your name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                            <span className="text-danger"></span>
                        </div>
                    </div>
                    <div className="form-field">
                        <label>Username</label>
                        <div className="input-group">
                            <input placeholder="Your username" type="text" value={userName} onChange={(e) => setUserName(e.target.value)} />
                            <span className="text-danger"></span>
                        </div>
                    </div>
                    <div className="form-field">
                        <label>Password</label>
                        <div className="input-group">
                            <input placeholder="Enter password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            <span className="text-danger"></span>
                        </div>
                    </div>
                    <div className="form-field">
                        <input type="submit" value="Register" className="btn btn-primary" />
                    </div>
                </form>
                <p>Already have account? <span onClick={() => setIsLogin(true)} className='change-btn'>Login here</span></p>
            </div>
            }
            <div className="photo-section"></div>
        </div >
    )
}
